export const middleMileMenuItems = [

   { label: "Dispatch Stock", path: "/operations/dispatch" },

  { label: "Manifest", path: "/master/branches" },

  { label: "In-Scan Manifest", path: "/operations/pickup-request" },

  { label: "Out Scan Manifest", path: "/master/customers" },

  { label: "Miss Route", path: "/master/vehicles" },

  { label: "In-Scan Trip Sheet", path: "/master/banks" },

  { label: "Out Scan Trip Sheet", path: "/master/zones" },
 
];